import { GlobalExclusionsWebComponent } from './component/GlobalExclusionsWebComponent';
import { WEB_COMPONENT_GLOBAL_EXCLUSIONS } from '../../webcomponents.constants';

/**
 * The component for displaying the exclusions from lists and from 'All exclusions'
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { GlobalExclusionsWebComponent };

window.customElements.define(WEB_COMPONENT_GLOBAL_EXCLUSIONS, GlobalExclusionsWebComponent);
